export const environment = {
    appVersion: require('../../package.json').version,
    production: false,
    apiUrl: 'https://app-api-aglet-uat5-eastus2.azurewebsites.net',
    environment: 'UAT5'
};
